import React, { useContext } from "react";
import { Helmet } from "react-helmet-async";
import { TestimonialContext, ServiceContext } from "../../App";
import MailSubscription from "../cards/emailSub";
import ContactForm from "../cards/contactForm";
import HeroSection from "../cards/hero";
import ClientGroup from "../groups/clientCardGroup";
import ServiceGroup from "../groups/serviceCardGroup";
import RecentJobGroup from "../groups/recentJobGroup";
import TeamGroup from "../groups/teamGroup";
import TestimonialGroup from "../groups/testimonialGroup";
import BlogGroup from "../groups/blogGroup";
import StartTechcareer from "../cards/TechCareer";

const Home = () => {
  const testimonials = useContext(TestimonialContext);
  const { service, serviceLoading } = useContext(ServiceContext);
  return (
    <>
      <Helmet>
        <title>Codehub Technologies</title>
      </Helmet>

      <HeroSection heroList={service} serviceLoading={serviceLoading} />
      <ClientGroup />
      <ServiceGroup type={true} />
      <StartTechcareer />
      <RecentJobGroup />
      <TeamGroup />
      <TestimonialGroup testimonialList={testimonials} />
      <BlogGroup />
      <MailSubscription />
      <ContactForm />
    </>
  );
};

export default Home;
